import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm } from "../../data/site";
import { homeMedia } from "../../data/homeMedia";
import { actionClass } from "../../utils/actionStyles";
export function Hero() {
  return <section aria-labelledby="hero-title" className="border-b border-line bg-ivory" data-id="element-191" data-mp="jnx6bkq0jvgo">
      <div className="page-container grid gap-10 py-12 md:py-16 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-192" data-mp="ep3urxuaeej5">
        <div className="lg:col-span-7" data-id="element-193" data-mp="apbipb5opq91">
          <h1 id="hero-title" className="text-h1-m font-extrabold text-ink md:text-h1" data-id="element-194" data-mp="am77httsxu8v">
            Michigan Motorcycle Accident Lawyer
          </h1>
          <p className="mt-5 max-w-measure text-slate md:mt-6" data-id="element-195" data-mp="rf76i8u4tae">
            Jason Waechter and his team help injured riders and families across Michigan understand their options
            after a serious motorcycle crash.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-196" data-mp="1v2aqaehnbqrf">
            <a href={firm.phoneHref} className={actionClass("call", "sm:px-7")} data-id="element-197" data-mp="1q5ts0rgqfw0m">
              <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-198" data-mp="1mvb30djoh8lp" />
              Call {firm.phoneDisplay}
            </a>
            <a href="#case-review" className={actionClass("outline", "sm:px-7")} data-id="element-199" data-mp="1rwqlbxuh110e">
              Free Case Review
            </a>
          </div>
          <a href="#case-result" className="mt-6 inline-block border-l-4 border-crimson pl-4 text-label font-bold text-ink underline underline-offset-4 hover:text-crimson" data-id="element-200" data-mp="1hwzohpifu9x5">
            See the $27.5 million motorcycle injury verdict
          </a>
        </div>
        <figure className="mx-auto w-full max-w-[480px] lg:col-span-5" data-id="element-201" data-mp="2al58ub5kxwwg">
          <img src={homeMedia.hero.src} srcSet={homeMedia.hero.srcSet} sizes="(min-width: 1024px) 480px, (min-width: 640px) 480px, calc(100vw - 40px)" width={homeMedia.hero.width} height={homeMedia.hero.height} alt={homeMedia.hero.alt} loading="eager" fetchPriority="high" decoding="async" className="block h-auto w-full rounded-lg border border-line" data-id="element-202" data-mp="1vw95usidra2p" />
          <figcaption className="mt-3 text-meta text-slate" data-id="element-203" data-mp="2y927sye33gyi">Jason Waechter, The Motorcycle Lawyer®</figcaption>
        </figure>
      </div>
    </section>;
}